module.exports = __webpack_public_path__ + "img/border-left.32f2275f.svg";